var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customer-dashboard" }, [
    _c("div", { staticClass: "md-layout" }, [
      _c("div", { staticClass: "md-layout-item" }, [
        _c("div", { staticClass: "custom-toolbar" }, [
          _c(
            "div",
            { staticClass: "custom-toolbar-start" },
            [
              _c("customer-filter-component", {
                attrs: { "team-region-id": _vm.filters.teamRegionId },
                on: { onFilterChanged: _vm.handleTeamRegionFilterChanged },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "custom-toolbar-end" },
            [
              _c("search-component", {
                ref: "search",
                on: { onSearch: _vm.handleSearch },
              }),
              _c(
                "div",
                { staticClass: "header-button-container" },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-primary md-just-icon md-round",
                      attrs: { title: "Create Customer" },
                      on: { click: _vm.createCustomer },
                    },
                    [_c("md-icon", [_vm._v("add")])],
                    1
                  ),
                  _c("input", {
                    ref: "fileInput",
                    staticStyle: { display: "none" },
                    attrs: { "data-testid": "upload-file", type: "file" },
                    on: { change: _vm.onFileSelected },
                  }),
                  !_vm.isSales
                    ? _c(
                        "md-button",
                        {
                          staticClass:
                            "md-primary md-just-icon md-round pull-right header-button",
                          attrs: { title: "Import Customers" },
                          on: {
                            click: function ($event) {
                              return _vm.$refs.fileInput.click()
                            },
                          },
                        },
                        [_c("md-icon", [_vm._v("publish")])],
                        1
                      )
                    : _vm._e(),
                  !_vm.isSales
                    ? _c(
                        "md-button",
                        {
                          staticClass:
                            "md-primary md-just-icon md-round pull-right header-button",
                          attrs: { title: "Export Customers" },
                          on: { click: _vm.exportCustomers },
                        },
                        [_c("md-icon", [_vm._v("get_app")])],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              !_vm.isSales
                ? _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "download-btn",
                        attrs: { download: "" },
                        on: { click: _vm.importTemplate },
                      },
                      [
                        _vm._v(
                          "\n                            Download Template\n                        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "md-layout" },
      [
        _c(
          "div",
          { staticClass: "md-layout-item" },
          [
            _c(
              "div",
              { staticClass: "error-message-container" },
              [
                _c("batch-upload-error-message", {
                  attrs: {
                    content: _vm.errorMessages,
                    "has-error-message": _vm.hasError,
                  },
                }),
              ],
              1
            ),
            _c(
              "md-card",
              [
                _c(
                  "md-card-header",
                  { staticClass: "md-card-header-icon md-card-header-green" },
                  [
                    _c(
                      "div",
                      { staticClass: "card-icon" },
                      [_c("md-icon", [_vm._v("contact_page")])],
                      1
                    ),
                  ]
                ),
                _c("md-card-content", { staticClass: "body-list" }, [
                  _vm.isListLoading
                    ? _c("div", { staticClass: "empty-table" }, [
                        _c(
                          "div",
                          { staticClass: "table-loader" },
                          [
                            _c("fade-loader", {
                              attrs: { loading: true, color: "#333333" },
                            }),
                            _c("span", [_vm._v("LOADING")]),
                          ],
                          1
                        ),
                      ])
                    : _c("div", [
                        _vm.customerList.length
                          ? _c(
                              "div",
                              [
                                _c(
                                  "md-table",
                                  {
                                    staticClass:
                                      "context-menu-support custom-paginated-table",
                                  },
                                  [
                                    _c(
                                      "md-table-row",
                                      [
                                        _c("md-table-head", [_vm._v("Name")]),
                                        _c("md-table-head", [_vm._v("Email")]),
                                        _c("md-table-head", [_vm._v("Phone")]),
                                        _c("md-table-head", [
                                          _vm._v("Address"),
                                        ]),
                                        !_vm.isSales
                                          ? _c("md-table-head", [
                                              _vm._v("Actions"),
                                            ])
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._l(_vm.customerList, function (item) {
                                      return _c(
                                        "md-table-row",
                                        {
                                          key: item.customerId,
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.showSidebar(
                                                item.customerId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "md-table-cell",
                                            [
                                              item.customerId
                                                ? _c(
                                                    "router-link",
                                                    {
                                                      staticClass:
                                                        "normal-link",
                                                      attrs: {
                                                        to: {
                                                          name: "Customer Details",
                                                          params: {
                                                            customerId:
                                                              item.customerId,
                                                          },
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(item.name) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              item.linkedUserAccount
                                                ? _c(
                                                    "md-icon",
                                                    {
                                                      staticClass: "green-icon",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            account_circle\n                                            "
                                                      ),
                                                      _c(
                                                        "md-tooltip",
                                                        {
                                                          attrs: {
                                                            "md-direction":
                                                              "right",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                This customer has a user login\n                                            "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c("md-table-cell", [
                                            _vm._v(_vm._s(item.email)),
                                          ]),
                                          _c("md-table-cell", [
                                            _vm._v(_vm._s(item.phone)),
                                          ]),
                                          _c("md-table-cell", [
                                            _vm._v(_vm._s(item.address)),
                                          ]),
                                          !_vm.isSales
                                            ? _c(
                                                "md-table-cell",
                                                {
                                                  staticClass: "action-buttons",
                                                },
                                                [
                                                  _c(
                                                    "md-button",
                                                    {
                                                      staticClass:
                                                        "md-warning md-just-icon md-round",
                                                      attrs: {
                                                        title:
                                                          "Update customer details",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.updateCustomer(
                                                            item.customerId
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("md-icon", [
                                                        _vm._v("edit"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "md-button",
                                                    {
                                                      staticClass:
                                                        "md-danger md-just-icon md-round",
                                                      attrs: {
                                                        title:
                                                          "Delete customer",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.handleDeleteCustomer(
                                                            item.customerId
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("md-icon", [
                                                        _vm._v("delete"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _c("div", [
                              _c("p", { staticClass: "no-result-message" }, [
                                _vm._v(
                                  "No results matching your search/filter could be found."
                                ),
                              ]),
                            ]),
                      ]),
                ]),
              ],
              1
            ),
            _c(
              "md-card-actions",
              {
                staticClass: "page-footer",
                attrs: { "md-alignment": "space-between" },
              },
              [
                _c("div", [
                  _vm.total === _vm.pagination.perPage
                    ? _c("p", { staticClass: "card-category" }, [
                        _vm._v(
                          "\n                        Page " +
                            _vm._s(_vm.pagination.currentPage) +
                            " of many\n                    "
                        ),
                      ])
                    : _c("p", { staticClass: "card-category" }, [
                        _vm._v(
                          "Page " +
                            _vm._s(_vm.pagination.currentPage) +
                            " of " +
                            _vm._s(_vm.totalPages)
                        ),
                      ]),
                ]),
                _c("pagination", {
                  staticClass: "pagination-no-border pagination-success",
                  attrs: {
                    "per-page": _vm.pagination.perPage,
                    total: _vm.total,
                  },
                  on: {
                    "change-page": function ($event) {
                      return _vm.handleChangePage(
                        $event,
                        _vm.pagination.perPage
                      )
                    },
                  },
                  model: {
                    value: _vm.pagination.currentPage,
                    callback: function ($$v) {
                      _vm.$set(_vm.pagination, "currentPage", $$v)
                    },
                    expression: "pagination.currentPage",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "transition",
          { attrs: { name: "slide" } },
          [
            _vm.isShowSidebar
              ? _c("customer-sidebar", {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.toggleSidebarWindow,
                      expression: "toggleSidebarWindow",
                    },
                  ],
                  attrs: { "customer-id": _vm.customerId },
                  on: { closeModal: _vm.toggleSidebarWindow },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }